const theme = {
  dark: "#011936",
  red: "#D8222A",
  light: "#D6D4A0",
  offwhite: "#f0f2ef",
  break: "1100px",
};

export default theme;
